module.exports = __webpack_public_path__ + "img/2.3.4.577b235a.jpg";